import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
function HeaderMenuConsumer({
  isMobile = false,
  closeMobileMenu
}: {
  isMobile?: boolean;
  closeMobileMenu?: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="28898" className="flex gap-4">
        <div className="h-4 w-16 bg-white/10 animate-pulse rounded-none" />
        <div className="h-4 w-16 bg-white/10 animate-pulse rounded-none" />
        <div className="h-4 w-16 bg-white/10 animate-pulse rounded-none" />
      </div>;
  }
  if (isMobile) {
    return <nav className="flex flex-col gap-6 items-center justify-center w-full">
        {menuItems.filter(item => item.label !== "Home2").map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-2xl font-light uppercase tracking-[0.3em] text-white hover:text-white/70 transition-colors" onClick={closeMobileMenu}>
            {item.label}
          </Link>)}
      </nav>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-8">
        {menuItems.filter(item => item.label !== "Home2").map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="relative block py-2 text-[11px] font-light uppercase tracking-[5px] text-white/80 transition-colors hover:text-white
                after:absolute after:bottom-0 after:left-1/2 after:h-[1px] after:w-0 after:-translate-x-1/2 after:bg-white after:transition-all after:duration-300 hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileMenuOpen]);
  return <section id="header" className="dark bg-black text-white w-full relative z-50">
      <header className={`sticky top-0 w-full transition-all duration-500 ease-in-out border-b text-white ${isScrolled ? "bg-black/80 backdrop-blur-xl border-white/15 py-3" : "bg-black border-transparent py-6"}`}>
        

        {}
        <div className={`fixed inset-0 bg-black/95 backdrop-blur-xl z-40 flex flex-col items-center justify-center transition-all duration-500 md:hidden ${isMobileMenuOpen ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"}`}>
          <MenuProvider menu_id="16">
            <HeaderMenuConsumer isMobile closeMobileMenu={() => setIsMobileMenuOpen(false)} />
          </MenuProvider>
        </div>
      </header>
    </section>;
}